import { createUseStyles } from "react-jss";
const useStyles = createUseStyles({
  container: {
    "@media (max-width:899.95px)": { width: "100%" },
    width: "63%",
    alignSelf: "center",
  },
  containerDocuments: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "15px",
  },
  containerContrat: {
    "@media (max-width:899.95px)": { flexDirection: "column" },
    display: "flex",
    flexDirection: "row",
    gap: "15px",
  },
  containerRequire: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    padding: "0px 15px 0px 15px",
    justifyContent: "flex-end",
    marginBottom: "20px",
  },
  containerAllButton: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingTop: "5px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  containerButton: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
  },
  containerGreyCardInput: {
    "@media (max-width:899.95px)": { flexDirection: "column" },
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    "& > div": {
      flex: 1,
    },
  },
});

export default useStyles;
